import styled from 'styled-components';

const Container = styled.div`
  padding: 10px 55px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const LevelItem = styled.div`
  border: 2px solid #2685d0;
  background-color: white;
  border-radius: 3px;
  color: #2685d0;
  padding: 6px 8px;
  text-align: center;
  font-size: 12px;

  &.active {
    background-color: #2685d0;
    border: 2px solid #2685d0;
    color: white;
  }
`;

const Level = styled.span`
  font-size: 17px;
`;

const Levels = ({ levels, currentLevel }) => (
  <Container>
    {
      levels.map((level, i) => (
        <LevelItem
          className={currentLevel === i && 'active'}
        >
          <div style={{ marginBottom: 3 }}>Level</div>
          <Level>{i + 1}</Level>
        </LevelItem>
      ))
    }
  </Container>
);

export default Levels;
